import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useState } from 'react'
import { BooleanInput, required, SimpleForm, TextInput, useNotify } from 'react-admin'
import { Button } from 'shared/components/Button/Button'
import { Text } from 'shared/components/Text/Text'
import { useOnboardingChecklist } from 'shared/hooks/query/useOnboardingChecklist'
import { manualHirerightCreateAndSync } from 'shared/models/backgroundCheck'
import { User } from 'shared/models/user'

interface UserOnboardingManuallySyncHirerightPackagesProps {
  user: User
}

export function UserOnboardingManuallySyncHirerightPackages({
  user,
}: UserOnboardingManuallySyncHirerightPackagesProps) {
  const notify = useNotify()
  const { refetch } = useOnboardingChecklist(user.id, { enabled: false })

  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const [formValues, setFormValues] = useState({
    hirerightRegID: '',
    isInitialPackage: false,
  })

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setLoading(false)
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await manualHirerightCreateAndSync(user.id, formValues.isInitialPackage, formValues.hirerightRegID)
      notify('Manual Hireright Sync Complete', { type: 'success' })
      refetch()
      handleClose()
    } catch (err) {
      notify(`Error: ${JSON.stringify(err)}`, { type: 'error' })
    }
    setLoading(false)
  }

  const handleFormChange = (name: string, value: any) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }))
  }

  return (
    <>
      <Button variant="text" size="small" onClick={handleOpen}>
        Manually Sync packages
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Manually Sync HireRight packages</DialogTitle>
        <DialogContent>
          <SimpleForm toolbar={false}>
            <Text variant="header2" align="left">
              Hireright Reg ID:
            </Text>
            <TextInput
              source="hirerightRegID"
              label="HireRight Registration ID"
              validate={[required()]}
              fullWidth
              onChange={(e) => handleFormChange('hirerightRegID', e.target.value)}
            />
            <BooleanInput
              source="isInitialPackage"
              label="Is Initial Package"
              validate={required()}
              initialValue={false}
              onChange={(value) => handleFormChange('isInitialPackage', value)}
            />
          </SimpleForm>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: '20px' }}>
          {' '}
          {/* Centered and padded */}
          <Button onClick={handleClose} variant="primary" size="large">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="primary" size="large" isDisabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'} {/* Loading indicator */}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
